import styled from "styled-components";
import { getCornerRadius } from "@swiggy-private/dls-web-common/dist/components/themes/CornerRadiusMapping/mapping";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { ITheme } from "@swiggy-private/dls-web-common/dist/components/types";
import { FullWidthButton } from "@swiggy-private/dls-web-core/dist/components/FullWidthButton";

export const Footer = styled.div(({ theme }) => ({
    marginTop: theme.spacing.empty,
    display: "flex",
    alignItems: "center",
}));

export const FooterFirst = styled.button(({ theme }) => ({
    width: "40%",
    background: "transparent",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column",
    borderRadius: `${getCornerRadius(theme, "xxSmall")} 0 0 ${getCornerRadius(theme, "xxSmall")}`,
    outline: "none",
}));

export const ViewBillText = styled(Text)(({ theme }) => ({
    marginToop: theme.spacing.xxxSmall,
}));

const baseButtonStyles = ({
    theme,
    isQuickCheckoutCartFlow,
}: {
    theme: ITheme;
    isPopCart?: boolean;
    isQuickCheckoutCartFlow?: boolean;
}) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "52px",
    background: theme.colors[theme.colorMode].special_positive,
    border: "1px solid transparent",
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.12)",
    borderRadius: getCornerRadius(theme, "small"),
    outline: "none",
    "&:disabled": {
        opacity: 0.8,
    },
    ...(isQuickCheckoutCartFlow && {
        background: theme.colors[theme.colorMode].positive,
    }),
});

export const MakePaymentButton = styled.div<{ isPopCart?: boolean; isQuickCheckoutCartFlow?: boolean }>(
    baseButtonStyles,
);

export const SelectDeliverySlotButton = styled.button<{ isPopCart?: boolean }>(baseButtonStyles);

export const FullWidthPayButton = styled(FullWidthButton)<{ isLoading?: boolean }>(({ theme, isLoading }) => ({
    background: theme.colors[theme.colorMode].positive,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "52px",
    borderRadius: theme.cornerRadius.small,
    boxShadow: "0 4px 8px 0 rgba(2, 6, 12, 0.25)",
    position: "relative",
    // styled(FullWidthButton) className lands on the inner <button>, not the outer wrapper.
    // DLS wraps children in Text maxLines={1} (-webkit-line-clamp), which on iOS clips the
    // subtitle ("Final Price") and ellipsizes the title. Reset that label wrapper.
    "& > div > div": {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: theme.spacing.xxxSmall,
        overflow: "visible",
        width: "auto",
        WebkitLineClamp: "unset",
        WebkitBoxOrient: "unset",
    },
    "&::after": {
        content: '""',
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        borderRadius: "inherit",
        border: `1px solid ${theme.colors[theme.colorMode].border_Subtle_Secondary}`,
        pointerEvents: "none",
    },
    ...(isLoading && {
        pointerEvents: "none",
    }),
}));

export const LoaderWrapper = styled.div({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
});

export const Title = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: theme.spacing.xxxSmall,
    flexShrink: 0,
    whiteSpace: "nowrap",
}));

export const Subtitle = styled.div({
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
});

export const Container = styled.div({
    width: "100%",
    position: "relative",
    "& > [data-theme]": {
        flex: 1,
        minWidth: 0,
    },
});

export const TextDivider = styled(Text)(({ theme }) => ({
    padding: `0 ${theme.spacing.xxxSmall}`,
}));
